import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import { createUrqlClient, theme } from "@therapprove/common";
import "@therapprove/common/src/lib-styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "urql";
import App from "./App/App";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

// Context just for reset
const UrqlResetContext = React.createContext<(() => void) | null>(null);
export const useUrqlReset = () => {
    const ctx = React.useContext(UrqlResetContext);
    if (!ctx)
        throw new Error("useUrqlReset must be used inside UrqlResetContext");
    return ctx;
};

const Root = () => {
    const [client, setClient] = React.useState(() => createUrqlClient());

    const resetClient = React.useCallback(() => {
        setClient(createUrqlClient());
    }, []);

    return (
        <React.StrictMode>
            <UrqlResetContext.Provider value={resetClient}>
                <Provider value={client}>
                    <MantineProvider theme={theme}>
                        <Notifications />
                        <ModalsProvider>
                            <App onSessionChange={resetClient} />
                        </ModalsProvider>
                    </MantineProvider>
                </Provider>
            </UrqlResetContext.Provider>
        </React.StrictMode>
    );
};

const root = ReactDOM.createRoot(rootElement);
root.render(<Root />);
